var styles = {"Anchor":"feBFPyem0vg-","AnchorBlock":"tDgBUKisLS4-","Container":"_5-yE5oWUWPs-","Tooltip":"_-1XZXRLzwUw-"};

export { styles as default };
//# sourceMappingURL=Tooltip.module.css.js.map
